import React, { useEffect, useState } from 'react';
import { useTitle } from '../contexts/TitleContext';
import { Box, Tabs, Tab } from '@mui/material';
import CustomTabPanel from '../components/CustomTabPanel/CustomTabPanel';
import AllGlobalSitelinksSection from '../components/SitelinkToolComponents/AllGlobalSitelinksSection';
import SitelinkGroupSection from '../components/SitelinkToolComponents/SitelinkGroupSection';

const SitelinkTool: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const { setTitle } = useTitle();
  useEffect(() => {
    setTitle(`Sitelink Tool`);
  }, [setTitle]);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '15px' }}>
        <Tabs value={tabValue} onChange={handleChangeTab} centered>
          <Tab label="Sitelinks" id="tab-1" aria-controls="tab-1" value={0} />
          <Box
            sx={{
              alignSelf: 'center',
              borderLeft: 1,
              borderWidth: 2,
              borderColor: 'divider',
              height: '32px',
            }}
          />
          <Tab label="Groups" id="tab-2" aria-controls="tab-2" value={1} />
        </Tabs>
      </Box>
      <CustomTabPanel value={tabValue} index={0}>
        <AllGlobalSitelinksSection />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <SitelinkGroupSection />
      </CustomTabPanel>
    </Box>
  );
};

export default SitelinkTool;
